import React from "react";
import { Field } from "formik";
import { Checkbox, ConfigProvider } from "antd";
import useThemeStore from "(store)/themeStore";

const CheckboxField = ({
  name,
  label,
  className,
  disabled = false,
  onChange,
  checked,
}) => {
  const theme = useThemeStore((state) => state.theme);

  return (
    <div className={`w-full ${className}`}>
      <div className="flex items-center">
        <Field name={name}>
          {({ field, form }) => (
            <div className="flex items-center rounded-lg">
              <ConfigProvider
                theme={{
                  components: {
                    Checkbox: {
                      colorPrimary: theme === "dark" ? "#FAB54E" : "#1996a6",
                      colorPrimaryHover:
                        theme === "dark" ? "#FAB54E" : "#1996a6",
                    },
                  },
                }}
              >
                <Checkbox
                  {...field}
                  checked={checked}
                  disabled={disabled}
                  onChange={(e) => {
                    if (onChange) onChange(e);
                  }}
                >
                  <span className="text dark:text-white">{label}</span>
                </Checkbox>
              </ConfigProvider>
            </div>
          )}
        </Field>
      </div>
    </div>
  );
};

export default CheckboxField;
